var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    d: "M31.529 8.93681C31.2376 8.76969 30.8792 8.77112 30.5893 8.94075L21.3125 14.3658V9.75C21.3125 9.41413 21.1328 9.10394 20.8415 8.93681C20.5501 8.76969 20.1917 8.77112 19.9018 8.94075L10.625 14.3658V0.9375C10.625 0.41975 10.2052 0 9.6875 0H0.9375C0.41975 0 0 0.41975 0 0.9375V31.0625C0 31.5802 0.41975 32 0.9375 32H31.0625C31.5802 32 32 31.5802 32 31.0625V9.75C32 9.41413 31.8203 9.10394 31.529 8.93681Z",
    fill: "#054089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6875 20.7188H13.4375C13.9552 20.7188 14.375 21.1385 14.375 21.6562V25.4062C14.375 25.924 13.9552 26.3438 13.4375 26.3438H9.6875C9.16975 26.3438 8.75 25.924 8.75 25.4062V21.6562C8.75 21.1385 9.16975 20.7188 9.6875 20.7188ZM10.625 24.4688H12.5V22.5938H10.625V24.4688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.375 20.7188H24.125C24.6427 20.7188 25.0625 21.1385 25.0625 21.6562V25.4062C25.0625 25.924 24.6427 26.3438 24.125 26.3438H20.375C19.8572 26.3438 19.4375 25.924 19.4375 25.4062V21.6562C19.4375 21.1385 19.8572 20.7188 20.375 20.7188ZM21.3125 24.4688H23.1875V22.5938H21.3125V24.4688Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.4f3a4d9a.svg";
export { ForwardRef as ReactComponent };